// extracted by mini-css-extract-plugin
export default {"selectItem":"drop-down-input_selectItem__7-q9P"};